import React from 'react';


export const HrElement = ({ className, children, attributes }) => {
  return (
    <>
      <div
        contentEditable={false}
        className={className}
        {...attributes}
      >
        <hr />
      </div>
      {children}
    </>
  );
};
